import { jsx } from "react/jsx-runtime";
import { Inclusion } from "@pcln/horizon";
import "react";
const ReviewSection = ({ type, text })=>/*#__PURE__*/ jsx("div", {
        children: 'up' === type ? /*#__PURE__*/ jsx(Inclusion, {
            labelNode: text,
            size: 'sm',
            icon: "thumb_up",
            slots: {
                inclusionSlot: 'text-benefit-8',
                iconSlot: '!hidden',
                inclusionIconSlot: 'text-benefit-8'
            }
        }) : /*#__PURE__*/ jsx(Inclusion, {
            labelNode: text,
            size: 'sm',
            icon: "thumb_down",
            slots: {
                inclusionSlot: 'text-benefit-8',
                iconSlot: '!hidden',
                inclusionIconSlot: 'text-neutral-10'
            }
        })
    });
const ReviewSummary_ReviewSection = ReviewSection;
export { ReviewSummary_ReviewSection as default };
